import type { GetToken } from '@clerk/types'

import { buildSubmitter } from '@/services/api'

const submitHeartbeat = buildSubmitter('/heartbeat')

export async function sendHeartbeat(getToken: GetToken): Promise<void> {
  await submitHeartbeat(getToken)
}
